import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, OnInit } from '@angular/core';
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { Slider } from 'src/app/model/slider';
import { resolvePublicAssetPath } from 'src/app/core/util/client-path.util';

@Component({
  selector: 'app-slider-emvs',
  templateUrl: './slider-emvs.component.html',
  styleUrls: ['./slider-emvs.component.css']
})
export class SliderEmvsComponent extends UnsubscribeOnDestroy implements OnInit {

  imageObject: Array<Slider> = [];
  private rawSlides: Slider[] = [];

  constructor(
    private servicioGeneral: ServicioGeneral,
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadSlider();
  }

  private loadSlider(): void {
    this.servicioGeneral.getSlider()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (value) => {
          this.rawSlides = value ?? [];
          this.applySlideTranslations();
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  private applySlideTranslations(): void {
    this.imageObject = this.rawSlides.map((slide) => ({
      ...slide,
      image: resolvePublicAssetPath(slide.image),
      thumbImage: resolvePublicAssetPath(slide.thumbImage),
      titleKey: `HOME.SLIDER.${slide.id}.TITLE`,
      descriptionKey: `HOME.SLIDER.${slide.id}.DESCRIPTION`,
    }));
  }
}
